'use client';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import { useState } from 'react';

export default function SPFeatures({ attributes }) {
  const [closeSection, setCloseSection] = useState(false);
  return (
    <>
      {attributes.length > 0 && (
        <div
          className="spFeatures mt-3 md:mt-8 md:p-8 p-0 bg-white text-xs md:text-base"
          id="spFeatures"
        >
          <div className="flex md:pb-6 md:pt-0 md:px-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
            <h2 className="spNavTitle font-bold  text-sm md:text-xl">
              مشخصات کالا
            </h2>
            <div
              className="md:hidden"
              onClick={() => setCloseSection((prev) => !prev)}
            >
              <ArrowTop className={`${closeSection && 'rotate-180'}`} />
            </div>
          </div>

          <div
            className={`${
              closeSection
                ? 'mt-0 p-0 h-0 overflow-hidden '
                : 'p-2 md:p-0 mt-4 md:mt-0 '
            }`}
          >
            <table className="text-gray-600 border border-[#efefef] rounded-md overflow-hidden w-full">
              <tbody>
                {attributes.map((attr, index) => (
                  <tr
                    className="bg-[#f6f6fb] border-b border-white"
                    key={index}
                  >
                    <td className="px-6 text-left py-2.5 font-light whitespace-nowrap width-[90px] md:min-w-[250px] border-l-4 border-white">
                      {attr.name}
                    </td>
                    <td className="px-6 w-full">
                      <div className="flex">
                        {attr.values.map((value, index) => (
                          <div key={index}>
                            <span key={index}>{value} </span>
                            <span>
                              {attr.values.length != index + 1 && ','}
                            </span>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
